import React from "react";
import { useOutletContext } from "react-router-dom";
import AboutUs from "../components/about_us";
import Faq from "../components/Faq";
import Cta from "../components/Cta";
import styles from "./HomePage.module.css";

export default function HomePage() {
  const { content, isRtl, text } = useOutletContext();

  return (
    <div className={styles.home}>
      <AboutUs title={text.Arabic9} description={content?.about_us} />
      <Faq
        isRtl={isRtl}
        faqheading={text.Arabicfaq}
        faqContent={content.faq || ""}
      />
      <Cta
        title={text.Arabic8}
        description={content.cta_content}
        socialLinks={content.social_links}
      />
    </div>
  );
}
